<template>
  <LegacyPageContent v-if="hasProfile && isAdmin">
    <v-row
      no-gutters
      align="center"
      class="mb-2"
    >
      <v-col>
        <div class="headline">
          Reports
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <h2 class="title">
          Select report you wish to extract and click on "Create reports" button below
        </h2>
      </v-col>
      <v-col cols="12">
        <h3 class="subtitle-1">
          When it's ready it will be sent to your email address
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <template v-for="(item, index) in reportTypes">
          <v-checkbox
            :key="index"
            v-model="selectedReports"
            :label="item.label"
            :value="item.value"
          />
        </template>
      </v-col>
    </v-row>

    <Dates
      start-date-label="Starting date"
      end-date-label="Ending date"
      :dates="this.dates"
    />

    <v-row>
      <v-col class="subtitle-1">
        If dates are not set, report will be created for all time
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          rounded
          color="primary"
          :loading="reportsInProgress"
          :disabled="createReportsBtnDisabled"
          @click="handleCreateReportsClick"
        >
          Create reports
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showReportsBuildingDialog"
      :retain-focus="false"
      transition="slide-y-transition"
    >
      <ConfirmDialog
        headline="Reports"
        @hide="handleReportsBuildingDialogClose"
        @confirm="handleReportsBuildingDialogClose"
      >
        Your reports are being created. As soon as they are ready, they will be sent to your email address!
      </ConfirmDialog>
    </v-dialog>
  </LegacyPageContent>
</template>
<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'

import ReportAPI from '@/services/report.service'
import { ReportType } from '@/types/models/report.model'
import LoadingProgress from '@/components/core/LoadingProgress.vue'
import Dates from '@/components/opportunities/create/Dates.vue'
import ConfirmDialog from '@/components/core/ConfirmDialog.vue'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'
import { waitAsync } from '@/utils/common'

interface IReportType {
  label: string
  value: ReportType
}

@Component({
  components: {
    LoadingProgress,
    Dates,
    ConfirmDialog,
    LegacyPageContent
  },
  computed: {
    ...mapGetters(['isAdmin'])
  }
})
export default class Rewards extends Vue {
  @Prop() hasProfile: boolean

  selectedReports: ReportType[] = []
  reportsInProgress: boolean = false
  showReportsBuildingDialog: boolean = false

  reportTypes: IReportType[] = [
    {
      label: 'Users report',
      value: ReportType.users
    },
    {
      label: 'Opportunities report',
      value: ReportType.opps
    },
    {
      label: 'Surveys report',
      value: ReportType.surveys
    },
    {
      label: 'Email newsletter subscription report',
      value: ReportType.users_email_subscription
    },
  ]

  dates = {
    start: {
      id: 'startDate',
      value: '',
    },
    end: {
      id: 'endDate',
      value: '',
    }
  }

  isAdmin: boolean
  get createReportsBtnDisabled () {
    return !this.selectedReports.length
  }

  async handleCreateReportsClick () {
    this.reportsInProgress = true
    if (!this.selectedReports.length) return

    const data = await ReportAPI.generateReports({
      reportNames: this.selectedReports,
      startDate: this.dates.start.value,
      endDate: this.dates.end.value
    }).catch(error => {
      this.$store.dispatch('setStatusError', error)
      return error
    })
    await waitAsync(1500)

    this.reportsInProgress = false
    if (data instanceof Error) return
    this.showReportsBuildingDialog = true
  }

  handleReportsBuildingDialogClose () {
    this.showReportsBuildingDialog = false
    this.reportsInProgress = false
    this.selectedReports = []
    Vue.set(this.dates.start, 'value', '')
    Vue.set(this.dates.end, 'value', '')
  }
}
</script>
